(function(){
  if(window.YCVCShippingProtectionInitialized)return;
  window.YCVCShippingProtectionInitialized=true;
  function root(){return (window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||"/";}
  document.addEventListener("change",async function(e){
    var toggle=e.target.closest("[data-shipping-protection-toggle]");
    if(!toggle)return;
    var wrap=toggle.closest("[data-shipping-protection]");
    if(!wrap)return;
    var variantId=wrap.getAttribute("data-variant-id");
    var message=wrap.querySelector("[data-shipping-protection-message]");
    toggle.disabled=true;
    if(message)message.textContent="Updating…";
    try{
      var cartRes=await fetch(root()+"cart.js",{credentials:"same-origin"});
      if(!cartRes.ok)throw new Error("Could not read cart");
      var cart=await cartRes.json();
      var line=cart.items.find(function(item){return String(item.variant_id)===String(variantId);});
      if(toggle.checked&&!line){
        var add=await fetch(root()+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({items:[{id:Number(variantId),quantity:1,properties:{"_ycvc_shipping_protection":"true"}}]})});
        if(!add.ok)throw new Error("Could not add protection");
      }else if(!toggle.checked&&line){
        var remove=await fetch(root()+"cart/change.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({id:line.key,quantity:0})});
        if(!remove.ok)throw new Error("Could not remove protection");
      }
      window.location.reload();
    }catch(err){
      toggle.checked=!toggle.checked;
      toggle.disabled=false;
      if(message)message.textContent="Could not update protection. Please try again.";
    }
  });
})();